module.exports = __webpack_public_path__ + "static/media/logo.c6280d9e.svg";